// extracted by mini-css-extract-plugin
module.exports = {"tabwrapper":"section-tab_tabwrapper__2dPl3","tabs":"section-tab_tabs__3hhOh"};